import vsComponent from './vsRadio'

export default Vue => {
  Vue.component(vsComponent.name, vsComponent)
}
